import useStateStore from 'services/store';
import './float-config-header.scss';
import { getConfigName } from 'services/utils';

const FloatConfigHeader = () => {
  const { setCurrentConfig, currentConfig, resetToDefault } = useStateStore();

  return (
    <div className="header">
      <span className="title">{getConfigName(currentConfig, 'name')}</span>
      <div className="right">
        <span onClick={resetToDefault} className="reset">
          reset to default
        </span>
        <span onClick={() => setCurrentConfig('')} className="cancel">
          <img src="images/cancel.svg" alt="" />
        </span>
      </div>
    </div>
  );
};

export default FloatConfigHeader;
